export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[960px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">关于布丁漫画</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            为韩漫爱好者而生的一站式免费阅读平台
          </p>
        </div>

        <div className="p-6 md:p-10 rounded-2xl bg-background-50 border border-background-200/70">
          <div className="prose prose-sm md:prose-base max-w-none text-foreground-600 space-y-4">
            <p className="leading-relaxed">
              布丁漫画成立于2024年，是一个专注于<strong className="text-foreground-950">韩漫免费阅读</strong>的在线平台。
              我们致力于为华语地区的韩漫爱好者提供<strong className="text-foreground-950">高质量、高画质、高更新频率</strong>的韩漫资源，
              涵盖恋爱、奇幻、悬疑、动作、职场等多元题材，满足不同读者的阅读偏好。
            </p>
            <p className="leading-relaxed">
              平台采用<strong className="text-foreground-950">下拉式阅读设计</strong>，还原韩国Webtoon原汁原味的浏览体验，
              让读者无需翻页即可沉浸式享受韩系画风的精致与剧情的张力。
              目前站内已收录超过<strong className="text-foreground-950">5000部韩漫作品</strong>，其中完结全集超过2000部，
              每日同步更新热门连载200余部，累计服务读者超过<strong className="text-foreground-950">300万人次</strong>。
            </p>
            <p className="leading-relaxed">
              布丁漫画团队由资深韩漫编辑、翻译和产品技术人员组成，
              坚持<strong className="text-foreground-950">免费、开放、优质</strong>的运营理念，
              以读者体验为核心持续优化平台功能与内容质量。
              未来我们将拓展更多韩漫正版合作渠道，丰富站内内容生态，
              为韩漫爱好者打造更完善的阅读社区。
            </p>
          </div>

          <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4">
            {[
              { num: '5000+', label: '收录韩漫' },
              { num: '200+', label: '日更作品' },
              { num: '300万+', label: '累计读者' },
              { num: '9.6', label: '读者评分' },
            ].map((stat, i) => (
              <div key={i} className="text-center p-4 rounded-xl bg-background-100">
                <div className="text-xl md:text-2xl font-bold text-primary-600 font-heading">{stat.num}</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}